/* eslint-disable object-shorthand */
/**
 * ! This file is auto-generated.
 * ! Please Do Not Modify! Changes will be overwritten.
 *
 * Exposes our SVG icon assets
 */
import React from 'react';
const accountLoading = React.lazy(() => import('assets/icons/naked/account-loading.svg'));
const accountSuccess = React.lazy(() => import('assets/icons/naked/account-success.svg'));
const alarm = React.lazy(() => import('assets/icons/naked/alarm.svg'));
const beachhouse = React.lazy(() => import('assets/icons/naked/beachhouse.svg'));
const bedHousemates = React.lazy(() => import('assets/icons/naked/bed-housemates.svg'));
const bedKidsModern = React.lazy(() => import('assets/icons/naked/bed-kids-modern.svg'));
const bedKids = React.lazy(() => import('assets/icons/naked/bed-kids.svg'));
const bedRoommates = React.lazy(() => import('assets/icons/naked/bed-roommates.svg'));
const bedSignificantOther = React.lazy(() => import('assets/icons/naked/bed-significant-other.svg'));
const bedSpouse = React.lazy(() => import('assets/icons/naked/bed-spouse.svg'));
const bicycle32 = React.lazy(() => import('assets/icons/naked/bicycle-32.svg'));
const bicycle48 = React.lazy(() => import('assets/icons/naked/bicycle-48.svg'));
const bicycleCircle = React.lazy(() => import('assets/icons/naked/bicycle-circle.svg'));
const bicycle = React.lazy(() => import('assets/icons/naked/bicycle.svg'));
const boomModern = React.lazy(() => import('assets/icons/naked/boom-modern.svg'));
const boom = React.lazy(() => import('assets/icons/naked/boom.svg'));
const building48 = React.lazy(() => import('assets/icons/naked/building-48.svg'));
const building = React.lazy(() => import('assets/icons/naked/building.svg'));
const burglarBars = React.lazy(() => import('assets/icons/naked/burglar-bars.svg'));
const business = React.lazy(() => import('assets/icons/naked/business.svg'));
const callColor = React.lazy(() => import('assets/icons/naked/call-color.svg'));
const camera32 = React.lazy(() => import('assets/icons/naked/camera-32.svg'));
const camera48 = React.lazy(() => import('assets/icons/naked/camera-48.svg'));
const cameraBig = React.lazy(() => import('assets/icons/naked/camera-big.svg'));
const cameraEquipment = React.lazy(() => import('assets/icons/naked/camera-equipment.svg'));
const cameraSmall = React.lazy(() => import('assets/icons/naked/camera-small.svg'));
const car48 = React.lazy(() => import('assets/icons/naked/car-48.svg'));
const car = React.lazy(() => import('assets/icons/naked/car.svg'));
const cardLoading = React.lazy(() => import('assets/icons/naked/card-loading.svg'));
const cat32 = React.lazy(() => import('assets/icons/naked/cat-32.svg'));
const cat48 = React.lazy(() => import('assets/icons/naked/cat-48.svg'));
const chairAboveAverageModern = React.lazy(() => import('assets/icons/naked/chair-above-average-modern.svg'));
const chairAboveAverage = React.lazy(() => import('assets/icons/naked/chair-above-average.svg'));
const chairAverage = React.lazy(() => import('assets/icons/naked/chair-average.svg'));
const chairFancy = React.lazy(() => import('assets/icons/naked/chair-fancy.svg'));
const chairHighEnd = React.lazy(() => import('assets/icons/naked/chair-high-end.svg'));
const chairStandard = React.lazy(() => import('assets/icons/naked/chair-standard.svg'));
const chevronRight = React.lazy(() => import('assets/icons/naked/chevron-right.svg'));
const crash = React.lazy(() => import('assets/icons/naked/crash.svg'));
const ctaBuilding = React.lazy(() => import('assets/icons/naked/cta-building.svg'));
const ctaCar = React.lazy(() => import('assets/icons/naked/cta-car.svg'));
const ctaContents = React.lazy(() => import('assets/icons/naked/cta-contents.svg'));
const ctaPet = React.lazy(() => import('assets/icons/naked/cta-pet.svg'));
const ctaSingleItems = React.lazy(() => import('assets/icons/naked/cta-single-items.svg'));
const ctaTowable = React.lazy(() => import('assets/icons/naked/cta-towable.svg'));
const dog32 = React.lazy(() => import('assets/icons/naked/dog-32.svg'));
const dog48 = React.lazy(() => import('assets/icons/naked/dog-48.svg'));
const dogDachshund48 = React.lazy(() => import('assets/icons/naked/dog-dachshund-48.svg'));
const drone = React.lazy(() => import('assets/icons/naked/drone.svg'));
const electricFence = React.lazy(() => import('assets/icons/naked/electric-fence.svg'));
const electronicsBig = React.lazy(() => import('assets/icons/naked/electronics-big.svg'));
const electronicsSmall = React.lazy(() => import('assets/icons/naked/electronics-small.svg'));
const emergencyTab = React.lazy(() => import('assets/icons/naked/emergency-tab.svg'));
const errorMail = React.lazy(() => import('assets/icons/naked/error-mail.svg'));
const extras = React.lazy(() => import('assets/icons/naked/extras.svg'));
const fence = React.lazy(() => import('assets/icons/naked/fence.svg'));
const furniture = React.lazy(() => import('assets/icons/naked/furniture.svg'));
const gate = React.lazy(() => import('assets/icons/naked/gate.svg'));
const glasses32 = React.lazy(() => import('assets/icons/naked/glasses-32.svg'));
const glasses48 = React.lazy(() => import('assets/icons/naked/glasses-48.svg'));
const glasses = React.lazy(() => import('assets/icons/naked/glasses.svg'));
const guard = React.lazy(() => import('assets/icons/naked/guard.svg'));
const guitar32 = React.lazy(() => import('assets/icons/naked/guitar-32.svg'));
const guitar48 = React.lazy(() => import('assets/icons/naked/guitar-48.svg'));
const guitar = React.lazy(() => import('assets/icons/naked/guitar.svg'));
const heart = React.lazy(() => import('assets/icons/naked/heart.svg'));
const helpTab = React.lazy(() => import('assets/icons/naked/help-tab.svg'));
const home48 = React.lazy(() => import('assets/icons/naked/home-48.svg'));
const homeAssistanceColor = React.lazy(() => import('assets/icons/naked/home-assistance-color.svg'));
const homeContents48 = React.lazy(() => import('assets/icons/naked/home-contents-48.svg'));
const homeTab = React.lazy(() => import('assets/icons/naked/home-tab.svg'));
const home = React.lazy(() => import('assets/icons/naked/home.svg'));
const hourglass = React.lazy(() => import('assets/icons/naked/hourglass.svg'));
const jewelleryBig = React.lazy(() => import('assets/icons/naked/jewellery-big.svg'));
const jewellerySmall = React.lazy(() => import('assets/icons/naked/jewellery-small.svg'));
const keys = React.lazy(() => import('assets/icons/naked/keys.svg'));
const laptop32 = React.lazy(() => import('assets/icons/naked/laptop-32.svg'));
const laptop48 = React.lazy(() => import('assets/icons/naked/laptop-48.svg'));
const laptop = React.lazy(() => import('assets/icons/naked/laptop.svg'));
const linkedAlarm = React.lazy(() => import('assets/icons/naked/linked-alarm.svg'));
const liveInIt = React.lazy(() => import('assets/icons/naked/live-in-it.svg'));
const medical32 = React.lazy(() => import('assets/icons/naked/medical-32.svg'));
const medical48 = React.lazy(() => import('assets/icons/naked/medical-48.svg'));
const medical = React.lazy(() => import('assets/icons/naked/medical.svg'));
const mediumCarCircle = React.lazy(() => import('assets/icons/naked/medium-car-circle.svg'));
const mediumCar = React.lazy(() => import('assets/icons/naked/medium-car.svg'));
const messageColor = React.lazy(() => import('assets/icons/naked/message-color.svg'));
const niceCarCircle = React.lazy(() => import('assets/icons/naked/nice-car-circle.svg'));
const niceCar = React.lazy(() => import('assets/icons/naked/nice-car.svg'));
const otherBig = React.lazy(() => import('assets/icons/naked/other-big.svg'));
const otherSmall = React.lazy(() => import('assets/icons/naked/other-small.svg'));
const owner = React.lazy(() => import('assets/icons/naked/owner.svg'));
const passwordReset = React.lazy(() => import('assets/icons/naked/password-reset.svg'));
const paymentProcess = React.lazy(() => import('assets/icons/naked/payment-process.svg'));
const paymentSuccess = React.lazy(() => import('assets/icons/naked/payment-success.svg'));
const phone32 = React.lazy(() => import('assets/icons/naked/phone-32.svg'));
const phone48 = React.lazy(() => import('assets/icons/naked/phone-48.svg'));
const phoneCallColor = React.lazy(() => import('assets/icons/naked/phone-call-color.svg'));
const phoneSmall = React.lazy(() => import('assets/icons/naked/phone-small.svg'));
const phone = React.lazy(() => import('assets/icons/naked/phone.svg'));
const planeColor = React.lazy(() => import('assets/icons/naked/plane-color.svg'));
const profileTabColor = React.lazy(() => import('assets/icons/naked/profile-tab-color.svg'));
const racket = React.lazy(() => import('assets/icons/naked/racket.svg'));
const rent = React.lazy(() => import('assets/icons/naked/rent.svg'));
const renter48 = React.lazy(() => import('assets/icons/naked/renter-48.svg'));
const ring32 = React.lazy(() => import('assets/icons/naked/ring-32.svg'));
const ring48 = React.lazy(() => import('assets/icons/naked/ring-48.svg'));
const ring = React.lazy(() => import('assets/icons/naked/ring.svg'));
const roadsideAssistanceColor = React.lazy(() => import('assets/icons/naked/roadside-assistance-color.svg'));
const roommate = React.lazy(() => import('assets/icons/naked/roommate.svg'));
const searchMail = React.lazy(() => import('assets/icons/naked/search-mail.svg'));
const search = React.lazy(() => import('assets/icons/naked/search.svg'));
const securityGates = React.lazy(() => import('assets/icons/naked/security-gates.svg'));
const securityGuard = React.lazy(() => import('assets/icons/naked/security-guard.svg'));
const sentColor = React.lazy(() => import('assets/icons/naked/sent-color.svg'));
const shortfall = React.lazy(() => import('assets/icons/naked/shortfall.svg'));
const singleItems = React.lazy(() => import('assets/icons/naked/single-items.svg'));
const smallCarCircle = React.lazy(() => import('assets/icons/naked/small-car-circle.svg'));
const sportsGearBig = React.lazy(() => import('assets/icons/naked/sports-gear-big.svg'));
const sportsGearSmall = React.lazy(() => import('assets/icons/naked/sports-gear-small.svg'));
const thatchRoof = React.lazy(() => import('assets/icons/naked/thatch-roof.svg'));
const thatchroof = React.lazy(() => import('assets/icons/naked/thatchroof.svg'));
const towable48 = React.lazy(() => import('assets/icons/naked/towable-48.svg'));
const towable = React.lazy(() => import('assets/icons/naked/towable.svg'));
const towtruckAssistanceColor = React.lazy(() => import('assets/icons/naked/towtruck-assistance-color.svg'));
const wallet = React.lazy(() => import('assets/icons/naked/wallet.svg'));
const watch32 = React.lazy(() => import('assets/icons/naked/watch-32.svg'));
const watch48 = React.lazy(() => import('assets/icons/naked/watch-48.svg'));
const watch = React.lazy(() => import('assets/icons/naked/watch.svg'));
const window = React.lazy(() => import('assets/icons/naked/window.svg'));
const wood = React.lazy(() => import('assets/icons/naked/wood.svg'));
const woodenConstruction = React.lazy(() => import('assets/icons/naked/wooden-construction.svg'));

export const ICONS = {
  'account-loading': accountLoading,
  'account-success': accountSuccess,
  'alarm': alarm,
  'beachhouse': beachhouse,
  'bed-housemates': bedHousemates,
  'bed-kids-modern': bedKidsModern,
  'bed-kids': bedKids,
  'bed-roommates': bedRoommates,
  'bed-significant-other': bedSignificantOther,
  'bed-spouse': bedSpouse,
  'bicycle-32': bicycle32,
  'bicycle-48': bicycle48,
  'bicycle-circle': bicycleCircle,
  'bicycle': bicycle,
  'boom-modern': boomModern,
  'boom': boom,
  'building-48': building48,
  'building': building,
  'burglar-bars': burglarBars,
  'business': business,
  'call-color': callColor,
  'camera-32': camera32,
  'camera-48': camera48,
  'camera-big': cameraBig,
  'camera-equipment': cameraEquipment,
  'camera-small': cameraSmall,
  'car-48': car48,
  'car': car,
  'card-loading': cardLoading,
  'cat-32': cat32,
  'cat-48': cat48,
  'chair-above-average-modern': chairAboveAverageModern,
  'chair-above-average': chairAboveAverage,
  'chair-average': chairAverage,
  'chair-fancy': chairFancy,
  'chair-high-end': chairHighEnd,
  'chair-standard': chairStandard,
  'chevron-right': chevronRight,
  'crash': crash,
  'cta-building': ctaBuilding,
  'cta-car': ctaCar,
  'cta-contents': ctaContents,
  'cta-pet': ctaPet,
  'cta-single-items': ctaSingleItems,
  'cta-towable': ctaTowable,
  'dog-32': dog32,
  'dog-48': dog48,
  'dog-dachshund-48': dogDachshund48,
  'drone': drone,
  'electric-fence': electricFence,
  'electronics-big': electronicsBig,
  'electronics-small': electronicsSmall,
  'emergency-tab': emergencyTab,
  'error-mail': errorMail,
  'extras': extras,
  'fence': fence,
  'furniture': furniture,
  'gate': gate,
  'glasses-32': glasses32,
  'glasses-48': glasses48,
  'glasses': glasses,
  'guard': guard,
  'guitar-32': guitar32,
  'guitar-48': guitar48,
  'guitar': guitar,
  'heart': heart,
  'help-tab': helpTab,
  'home-48': home48,
  'home-assistance-color': homeAssistanceColor,
  'home-contents-48': homeContents48,
  'home-tab': homeTab,
  'home': home,
  'hourglass': hourglass,
  'jewellery-big': jewelleryBig,
  'jewellery-small': jewellerySmall,
  'keys': keys,
  'laptop-32': laptop32,
  'laptop-48': laptop48,
  'laptop': laptop,
  'linked-alarm': linkedAlarm,
  'live-in-it': liveInIt,
  'medical-32': medical32,
  'medical-48': medical48,
  'medical': medical,
  'medium-car-circle': mediumCarCircle,
  'medium-car': mediumCar,
  'message-color': messageColor,
  'nice-car-circle': niceCarCircle,
  'nice-car': niceCar,
  'other-big': otherBig,
  'other-small': otherSmall,
  'owner': owner,
  'password-reset': passwordReset,
  'payment-process': paymentProcess,
  'payment-success': paymentSuccess,
  'phone-32': phone32,
  'phone-48': phone48,
  'phone-call-color': phoneCallColor,
  'phone-small': phoneSmall,
  'phone': phone,
  'plane-color': planeColor,
  'profile-tab-color': profileTabColor,
  'racket': racket,
  'rent': rent,
  'renter-48': renter48,
  'ring-32': ring32,
  'ring-48': ring48,
  'ring': ring,
  'roadside-assistance-color': roadsideAssistanceColor,
  'roommate': roommate,
  'search-mail': searchMail,
  'search': search,
  'security-gates': securityGates,
  'security-guard': securityGuard,
  'sent-color': sentColor,
  'shortfall': shortfall,
  'single-items': singleItems,
  'small-car-circle': smallCarCircle,
  'sports-gear-big': sportsGearBig,
  'sports-gear-small': sportsGearSmall,
  'thatch-roof': thatchRoof,
  'thatchroof': thatchroof,
  'towable-48': towable48,
  'towable': towable,
  'towtruck-assistance-color': towtruckAssistanceColor,
  'wallet': wallet,
  'watch-32': watch32,
  'watch-48': watch48,
  'watch': watch,
  'window': window,
  'wood': wood,
  'wooden-construction': woodenConstruction,
};
